/**
 * Talala API Gateway
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface User {
  user_name: string;
  person_name?: string;
  user_bio?: string;
  user_id: string;
  user_avatar_url?: string;
  is_blocked?: boolean;
  is_identity_confirmed?: boolean;
}
